/**
 * @generated SignedSource<<68033ec22fabc7e8a058dde3f59cbad3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type HeroBannerSettingsImageWidth = "full" | "half" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type HpSharedHeroBannerText_heroBannerSettings$data = {
  readonly bannerImageWidth: HeroBannerSettingsImageWidth | null;
  readonly contentColor: string | null;
  readonly ctaStyle: string | null;
  readonly dekText: string | null;
  readonly eyeBrowText: string | null;
  readonly headerText: string | null;
  readonly textAlignment: string | null;
  readonly " $fragmentType": "HpSharedHeroBannerText_heroBannerSettings";
};
export type HpSharedHeroBannerText_heroBannerSettings$key = {
  readonly " $data"?: HpSharedHeroBannerText_heroBannerSettings$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedHeroBannerText_heroBannerSettings">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedHeroBannerText_heroBannerSettings",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "textAlignment",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contentColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eyeBrowText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "headerText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dekText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ctaStyle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bannerImageWidth",
      "storageKey": null
    }
  ],
  "type": "HeroBannerSettingsType",
  "abstractKey": null
};

(node as any).hash = "fe3f99a79602d6db2ace10c6991fbd8f";

export default node;
